<template>
  <span title="Delete">
    <feather-icon
      id="popover-button-1"
      icon="TrashIcon"
      class="cursor-pointer"
      @click="deleteRow(data.item.id)"
    />
  </span>
</template>

<script>
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { isString } from 'lodash'
import decryptData from '@/store/auth/decryptData'

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    apiUrl: {
      type: String,
      default: () => '',
    },
    getAllData: {
      type: Function,
      default: () => {},
    },
  },
  methods: {

    deleteRow(id) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then(result => {
        if (result.isConfirmed) {
          const baseUrl = this.apiUrl.indexOf('?') !== -1 ? this.apiUrl.slice(0, this.apiUrl.indexOf('?')) : this.apiUrl
          const apiUrlUsed = (baseUrl === 'audit/pending' || baseUrl === 'audit/completed') ? 'audit' : baseUrl
          axios
            .delete(`${apiUrlUsed}/${id}`)
            .then(() => {
              this.$swal('Deleted!', 'Deleted Successfully.', 'success')
              this.getAllData()
            }).catch(error => {
              const payload = decryptData(error.response.data.payload).message
              let errorMessage = ''
              if (isString(payload)) {
                errorMessage = payload
              } else {
                const firstArrayKey = Object.keys(payload).find(key => Array.isArray(payload[key]))
                errorMessage = firstArrayKey ? payload[firstArrayKey][0] : 'An unknown error occurred'
              }
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errorMessage,
                  icon: 'BellIcon',
                  variant: 'error',
                },
              })
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
  },
}
</script>
